import * as React from "react";

const SvgComponent = ({ width = "11px", height = "15px", bg, ...props }) => (
  <svg
    width={width}
    height={height}
    fill={"none"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 11 15"
    {...props}
  >
    <path
      d="M10.12 2.034A1.177 1.177 0 0 0 9.311 0H.504A.504.504 0 0 0 0 .504v13.992a.505.505 0 0 0 1.009 0V8.589H9.31a1.177 1.177 0 0 0 .808-2.034L7.846 4.417a.168.168 0 0 1 0-.246l2.273-2.137Z"
      fill={bg}
    />
  </svg>
);

export default SvgComponent;
